var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramWhiteBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 12.5,
    cy: 12,
    r: 10.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7399 7.65659C17.8334 7.05249 17.2591 6.57567 16.7219 6.8115L6.02361 11.5086C5.63842 11.6778 5.6666 12.2612 6.0661 12.3884L8.27236 13.091C8.69344 13.2251 9.14939 13.1558 9.51709 12.9017L14.4912 9.4652C14.6412 9.36157 14.8047 9.57485 14.6766 9.70697L11.0961 13.3985C10.7488 13.7566 10.8177 14.3634 11.2355 14.6254L15.2442 17.1392C15.6938 17.4212 16.2723 17.1379 16.3564 16.5946L17.7399 7.65659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7399 7.65659C17.8334 7.05249 17.2591 6.57567 16.7219 6.8115L6.02361 11.5086C5.63842 11.6778 5.6666 12.2612 6.0661 12.3884L8.27236 13.091C8.69344 13.2251 9.14939 13.1558 9.51709 12.9017L14.4912 9.4652C14.6412 9.36157 14.8047 9.57485 14.6766 9.70697L11.0961 13.3985C10.7488 13.7566 10.8177 14.3634 11.2355 14.6254L15.2442 17.1392C15.6938 17.4212 16.2723 17.1379 16.3564 16.5946L17.7399 7.65659Z",
    fill: "url(#paint0_linear_430_518685)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_430_518685",
    x1: 11.75,
    y1: 6.75,
    x2: 11.75,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhiteBg);
export default __webpack_public_path__ + "static/media/telegram-white-bg.c37eea031749b05f8a2447e71d726338.svg";
export { ForwardRef as ReactComponent };